import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IApproveOrderPayload {
    id: string
    data?: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const approveOrder = createSlice({
    name: 'order/approve',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IApproveOrderPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const approveOrderActions = approveOrder.actions
export default approveOrder.reducer
